import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { generateTelegramLink, TELEGRAM_BASE } from "../data/telegramLinks";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useLanguage();

  const links = [
    { label: t("footerLinkAccess"), href: "#accesses" },
    { label: t("footerLinkHelp"), href: "#help" },
    { label: t("footerLinkCodes"), href: "#codes" },
    { label: t("footerLinkReviews"), href: "#reviews" },
    { label: t("footerLinkSupport"), href: TELEGRAM_BASE, external: true },
    { label: t("footerLinkFAQ"), href: "#faq" },
  ];

  return (
    <footer className="relative pt-20 md:pt-28 pb-10 px-5 md:px-10 lg:px-16 border-t border-[#D8DCE2]/8" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-6 text-[14px] text-[#D8DCE2]/70 leading-relaxed max-w-md">
              {t("footerDesc")}
            </p>
            <a
              href={generateTelegramLink("private-support")}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#1A1C22] border border-[#D7B56D]/30 text-[12px] font-bold tracking-tight text-[#F5F1EA] hover:bg-[#D7B56D] hover:text-[#0a0b0f] transition-colors"
              data-testid="footer-telegram-cta"
            >
              <MessageCircle size={13} /> {t("ctaAskTelegram")} <ArrowRight size={12} />
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A9824A] mb-5">
              Navigation
            </div>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    target={l.external ? "_blank" : undefined}
                    rel={l.external ? "noopener noreferrer" : undefined}
                    className="text-[13px] text-[#D8DCE2]/80 hover:text-[#D7B56D] transition-colors"
                    data-testid={`footer-link-${l.label}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A9824A] mb-5">
              Disclaimer
            </div>
            <p className="text-[12px] text-[#D8DCE2]/55 leading-relaxed mb-3">{t("disclaimer")}</p>
            <p className="text-[11px] text-[#D8DCE2]/40 leading-relaxed">{t("footerLegal")}</p>
          </div>
        </div>

        <div className="pt-6 border-t border-[#D8DCE2]/8 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A9824A]">
            © {new Date().getFullYear()} MarketEdge Access Lab · {t("footerRights")}
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#76D9E8]">
            Education only · No financial advice
          </p>
        </div>
      </div>
    </footer>
  );
};
